<template>
  <section class="file-wrapper">
    <div class="top-heading">
      <h2>Photo Collection 2020</h2>
      <span>0 Files</span>
    </div>
    <div class="no-data" style="display: none">
      <img src="images/ic_blank_data.svg" alt />
      <span>No Data Found</span>
    </div>
    <!-- <div class="fill-data"> -->
    <div class="close-option"></div>
    
    <!-- <ul class="folder-listing"> -->
    <folder />
    <loader91 v-if="isLoading"></loader91>
  </section>
</template>
<script>
import folder from "../components/folder";
import { mapGetters } from "vuex";
import "../js/loading-bar.js";
export default {
  name: "File",
  components: {
    folder
  },
  data() {
    return {
      folder: this.$route.params.name,
      isLoading:true
    };
  },
  computed: {
    ...mapGetters(["getUserFile","getFolderId"])
  },
  watch:{
    '$route.params.name'(to,from){
      console.log(to,from);
      this.userFile()
    },
    
  },
  mounted(){
this.isLoading=false;
  },
 
  methods:{
    async userFile() {
      this.isLoading=true
      
      let file_id_string = this.$route.params.name.split('/');
      let file_id = file_id_string[file_id_string.length - 1];
      await this.$store.dispatch("userFile", {
        headers: {
          "folder-id": file_id,
          limit: 0
        }
      },
      //  this.isLoading = false,
       ) .then((data) => {
          // this.$toast.bottom("Rename successfull");
          this.isLoading = false;
        });
    },
  }
};
</script>